import React from 'react';

import { Spinner, getDisplayName } from '@cp-shared-19/frontend-ui';

export type withLoadingHandlerProps = {
    isLoading: boolean;
};

export const withLoadingHandler = <TProps extends object>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withLoadingHandlerProps> => {
    const Wrapper: React.FC<TProps & withLoadingHandlerProps> = ({ isLoading, ...props }: withLoadingHandlerProps) =>
        isLoading ? <Spinner center={true} /> : <WrappedComponent {...(props as TProps)} />;

    Wrapper.displayName = `withLoadingHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
